// extracted by mini-css-extract-plugin
module.exports = {"min":"PriceRent_min__hjZOT","big":"PriceRent_big__1VtOX","skeletonTiny":"PriceRent_skeletonTiny__2a155","skeletonBig":"PriceRent_skeletonBig__2rTJQ"};